import { useNewEditTemplateCollectionBody } from "../../hooks/useNewEditTemplateCollectionBody"
import CollectionEditTable from "./components/CollectionEditTable/CollectionEditTable"
import DownloadTemplateCollection from "./components/DownloadTemplateCollection/DownloadTemplateCollection"
import { NewEditTemplateCollectionBodyTableContextProvider } from "./context/NewEditTemplateCollectionBodyTableContext"
import './styles.css'

const NewEditTemplateCollectionBodyTable = () => {
  const { chargeDebtorsData } = useNewEditTemplateCollectionBody()

  return (
    <div className="new-edit-template-collection-body-table">
      <NewEditTemplateCollectionBodyTableContextProvider>
        {
          chargeDebtorsData?.dataSource?.length ?
            <CollectionEditTable /> :
            <DownloadTemplateCollection />
        }
      </NewEditTemplateCollectionBodyTableContextProvider>
    </div>
  )
}

export default NewEditTemplateCollectionBodyTable
